import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "step__basic" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите тип конструкции", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Нажмите, чтобы выбрать тип конструкции из списка", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите место установки", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Нажмите, чтобы выбрать место установки из списка", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите номер места", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Нажмите, чтобы выбрать номер места из списка", -1)
const _hoisted_9 = { for: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.construction_type_title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.construction_type_title) = $event)),
          editable: "",
          options: _ctx.construction_type_options,
          optionLabel: "name",
          placeholder: _ctx.construction_type_default.name,
          style: {"width":"480px"},
          onChange: _ctx.construction_type_change
        }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.place_install_title,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.place_install_title) = $event)),
          editable: "",
          options: _ctx.place_install_options,
          optionLabel: "name",
          placeholder: _ctx.place_install_default.name,
          style: {"width":"480px"},
          onChange: _ctx.place_install_change
        }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_7,
        _hoisted_8,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.place_number_title,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.place_number_title) = $event)),
          editable: "",
          options: _ctx.place_number_options,
          optionLabel: "name",
          placeholder: _ctx.place_number_default.name,
          style: {"width":"480px"},
          onChange: _ctx.place_number_change
        }, null, 8, ["modelValue", "options", "placeholder", "onChange"]),
        (_ctx.document.place_number === 'manual')
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "input",
              type: "text",
              placeholder: "Введите номер места",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.place_manual) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.document.place_manual]
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", null, [
        _createElementVNode("label", _hoisted_9, [
          _createVNode(_component_v_switch, {
            style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
            color: "#2F80ED",
            modelValue: _ctx.document.construction_app6,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.construction_app6) = $event)),
            label: "Согласовывается по факту, используя приложение №6",
            inline: ""
          }, null, 8, ["modelValue"])
        ])
      ])
    ])
  ]))
}